var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.834,
    height: 14.837,
    viewBox: "0 0 14.834 14.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49370",
    "data-name": "Group 49370",
    transform: "translate(-2206.717 9875.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93663",
    "data-name": "Path 93663",
    d: "M19.69,13.255a6.649,6.649,0,1,0,2.6.525A6.614,6.614,0,0,0,19.69,13.255Z",
    transform: "translate(2194.444 -9887.592)",
    fill: "none",
    stroke: "#06c258",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93665",
    "data-name": "Path 93665",
    d: "M2211.007-9866.471l2.293,2.069,4.183-4.363",
    transform: "translate(0 -1.085)",
    fill: "none",
    stroke: "#06c258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/Selected.790627a4ec1acb0802db357a8656efb7.svg";
export { ForwardRef as ReactComponent };